/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import styled from "styled-components";

const parentContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto 0 auto;

  @media(max-width:768px) {
    padding-left:2rem;
    padding-right:2rem;
  }
`;

export default parentContainer;
